import { render } from "./HeadingComponent.vue?vue&type=template&id=21e45cf8"
import script from "./HeadingComponent.vue?vue&type=script&lang=js"
export * from "./HeadingComponent.vue?vue&type=script&lang=js"

import "./HeadingComponent.vue?vue&type=style&index=0&id=21e45cf8&lang=css"

import exportComponent from "/home/ecuflower/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__